$(document).ready(function(){
  $('.new-testimonials').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    autoplay: false,
    autoplaySpeed: 3000,
    infinite: true,
    responsive: [
      {
        breakpoint: 1024, // laptops / tablets
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 768, // tablets portrait
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480, // mobile
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true
        }
      }
    ]
  });
});





document.addEventListener("DOMContentLoaded", function() {
  var newsletterInput = document.getElementById("input--template--19844146528502__newsletter--contactemail");
  if (newsletterInput) {
    newsletterInput.setAttribute("placeholder", "Enter Email Address");
  }
});


document.addEventListener("DOMContentLoaded", function() {
  const popover = document.getElementById("popover-localization-header-nav-sections--19844147380470__header-country");
  if (popover) {
    popover.removeAttribute("open"); // page load pe close
    popover.style.display = "none";  // hide bhi kar do
  }
});




document.addEventListener("DOMContentLoaded", function () {
  const btn = document.querySelector(".next-sec-btn");

  if (btn) {
    btn.addEventListener("click", function () {
      console.log("✅ Button clicked");

      // Banner section find karo
      const banner = btn.closest(".shopify-section");

      if (banner) {
        // Shopify ka agla section
        let nextSection = banner.nextElementSibling;

        if (nextSection) {
          console.log("➡️ Scrolling to:", nextSection.id);
          nextSection.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        } else {
          console.error("❌ Next section nahi mila.");
        }
      }
    });
  }
});



